import { environmentHttpClient } from "../httpClient";

export type DomainName = {
	value: string;
};

export type SecurityConfigurationViewModel = {
	cspFrameAncestorDomains: readonly DomainName[];
};

export type SecurityConfigurationSaveModel = {
	cspFrameAncestorDomains: readonly DomainName[];
};

export function load(signal?: AbortSignal): Promise<SecurityConfigurationViewModel> {
	return environmentHttpClient.get<SecurityConfigurationViewModel>(
		"/UiApi/SecurityConfiguration",
		undefined,
		{ signal }
	);
}

export function save(model: SecurityConfigurationSaveModel, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UiApi/SecurityConfiguration",
		model,
		{ signal }
	);
}
